import { render, staticRenderFns } from "./manageUserModels.vue?vue&type=template&id=cf0e8e88&scoped=true&"
import script from "./manageUserModels.vue?vue&type=script&lang=js&"
export * from "./manageUserModels.vue?vue&type=script&lang=js&"
import style0 from "./manageUserModels.vue?vue&type=style&index=0&id=cf0e8e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0e8e88",
  null
  
)

export default component.exports